<script>
export default {
    name: 'DisplayRate',
    props: {
        model: null,
        reverse: Boolean,
        size: String,
    },
    computed: {
        rating() {
            return Math.round(this.model?.rating || this.model?.rating_average || 0) / 2
        },
    },
}
</script>

<template lang="pug">
.display-rate.d-inline-flex.align-items-baseline.justify-content-center.font-weight-semibold.text-73.line-1(v-if="rating > 0" :class="size ? `text-${size}` : undefined")
    span.text-m(:class="[size ? `text-${size}` : undefined, {'order-1': reverse}]") {{rating}}
    icon(icon="fa-solid fa-star" size="xs" :class="reverse ? 'order-0 mr-2' : 'ml-2'")

</template>
